import React, { useState } from 'react';
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../utils/firebase';
import { ToastContainer, toast } from 'react-toastify';
import { getAuthErrorMessage, checkEmpty } from "../utils/Helper";

/**
 * ForgotPassword
 * Toggles between a hidden state and a glassmorphism recovery form.
 * Includes console logging for troubleshooting email delivery.
 */
const ForgotPassword = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();

        // Basic Validation
        if (checkEmpty(email)) {
            toast.error("Please enter your email address.");
            return;
        }

        console.log("--- Password Reset Debug ---");
        console.log("Target Email:", email);
        setLoading(true);

        try {
            // Firebase Reset Logic
            await sendPasswordResetEmail(auth, email);
            
            // If we reach here, Firebase accepted the request
            console.log("Result: Firebase accepted the request. Check your inbox/spam.");
            toast.success("Reset link sent! Please check your inbox.");
            
            // Auto-close form after success
            setTimeout(() => {
                resetForm();
            }, 4000);
        } catch (error) {
            // Log the specific error code for troubleshooting
            console.error("Firebase Error Code:", error.code);
            console.error("Firebase Error Message:", error.message);
            
            toast.error(getAuthErrorMessage(error.code));
        } finally {
            setLoading(false);
            console.log("--- End Debug ---");
        }
    };

    const resetForm = () => {
        setEmail('');
        setIsOpen(false);
    };

    // 1. HIDDEN STATE (Trigger Link)
    if (!isOpen) {
        return (
            <div className="forgot-password-trigger" style={{ textAlign: 'center', marginTop: '15px' }}>
                <button 
                    type="button"
                    className="btn-sort-pill" 
                    onClick={() => setIsOpen(true)}
                    style={{ 
                        border: 'none', 
                        background: 'transparent', 
                        cursor: 'pointer', 
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        color: 'rgba(255,255,255,0.6)'
                    }}
                >
                    Forgot Password?
                </button>
            </div>
        );
    }

    // 2. OPEN STATE (Glassmorphism Form)
    return (
        <div className="auth-card glass-modal-content animate-fade-in" style={{ marginTop: '15px', padding: '20px', border: '1px solid rgba(129, 236, 237, 0.2)' }}>
            <h3 className="auth-title" style={{ fontSize: '1rem', marginBottom: '15px', color: '#81ecedff' }}>
                Recover Account
            </h3>
            
            <form onSubmit={handleReset}>
                <div className="auth-form-group">
                    <label className="meta-label gold-accent">Registered Email</label>
                    <input
                        type="email"
                        className="glass-input"
                        placeholder="name@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{ marginBottom: '10px' }}
                    />
                </div>

                <div className="d-flex gap-2" style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-glass-save-edit"
                        style={{ flex: 2, padding: '10px', fontSize: '12px' }}
                    >
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                    
                    <button
                        type="button"
                        className="btn-delete-circle"
                        onClick={resetForm}
                        style={{ 
                            flex: '0 0 40px', 
                            height: '40px', 
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        ✕
                    </button>
                </div>
            </form>

            <ToastContainer 
                position="bottom-center" 
                autoClose={4000} 
                theme="dark" 
            />
        </div>
    );
};

export default ForgotPassword;